import { createContext } from "react";
import { User } from "oidc-client-ts";
import { AuthContextType } from "./AuthContext.interface";

export const AuthContext = createContext<AuthContextType>({
  getUser: () => {
    return new Promise<User>(() => {
      return;
    });
  },
  signinRedirectCallback: () => {
    return;
  },
  logout: () => {
    return;
  },
  signoutRedirectCallback: () => {
    return;
  },
  isAuthenticated: () => false,
  signinRedirect: () => {
    return;
  },
  signoutRedirect: () => {
    return;
  },
  signinSilent: () => {
    return;
  },
  signinSilentCallback: () => {
    return;
  },
  checkReAuth: () => false,
});
